import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PartnerProvider } from './context/PartnerContext';
import { PaymentProvider } from './context/PaymentContext';

import SkylabHeader from './components/shared/SkylabHeader';
import SkylabFooter from './components/shared/SkylabFooter';
import ErrorBoundary from './components/shared/ErrorBoundary';

import './App.css';

const LandingPage = lazy(() => import('./components/pages/LandingPage'));
const DirectLandingPage = lazy(() => import('./components/pages/DirectLandingPage'));
const CheckoutPage = lazy(() => import('./components/pages/CheckoutPage'));
const CookiesPage = lazy(() => import('./components/pages/CookiesPage'));


const NotFoundPage: React.FC = () => (
  <div className="not-found-page">
    <div className="not-found-content">
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <p>Please return to the cart and try again.</p>
    </div>
  </div>
);

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="app">
    <SkylabHeader partnerName="MyLodgeTax" />
    <div className="s-container">
      <main className="main-content">
        {children}
      </main>
    </div>
    <SkylabFooter />
  </div>
);

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <PartnerProvider>
        <PaymentProvider>
          <Router>
            <Suspense fallback={null}>
              <Routes>
                <Route 
                  path="/partner/:leadId" 
                  element={
                    <MainLayout>
                      <LandingPage />
                    </MainLayout>
                  } 
                />
                <Route 
                  path="/partner/" 
                  element={
                    <MainLayout>
                      <LandingPage />
                    </MainLayout>
                  } 
                />
                
                <Route 
                  path="/partner/checkout/:tab" 
                  element={
                    <MainLayout>
                      <CheckoutPage />
                    </MainLayout>
                  } 
                />
                
                <Route 
                  path="/checkout/:tab" 
                  element={
                    <MainLayout>
                      <CheckoutPage />
                    </MainLayout>
                  } 
                />

                <Route
                  path="/"
                  element={
                    <MainLayout>
                      <DirectLandingPage />
                    </MainLayout>
                  }
                />

                <Route
                  path="/cookies"
                  element={
                    <MainLayout>
                      <CookiesPage />
                    </MainLayout>
                  }
                />

                <Route 
                  path="*" 
                  element={<NotFoundPage />} 
                />
              </Routes>
            </Suspense>
          </Router>
        </PaymentProvider>
      </PartnerProvider>
    </ErrorBoundary>
  );
};

export default App; 